// extracted by mini-css-extract-plugin
export var container = "prefecture-selection-view-module--container--1jJE9";
export var regionText = "prefecture-selection-view-module--regionText--3p93X";
export var prefectureRow = "prefecture-selection-view-module--prefectureRow--1cKK0";
export var prefectureLinkText = "prefecture-selection-view-module--prefectureLinkText--1jAMk";